/** These cover hosts reject third-party referrers. */
export function coverReferrerPolicy(url?: string): 'no-referrer' | undefined {
  if (!url) return undefined;
  try { return ['uploads.mangadex.org', 'animeflv.or.at'].includes(new URL(url).hostname) ? 'no-referrer' : undefined; }
  catch { return undefined; }
}

export function coverImageUrl(url?: string): string | undefined {
  if (!url) return url;
  const parsed = new URL(url!);
  if (parsed.hostname !== 'uploads.mangadex.org') return url;
  // Discard previously cached hotlink notices without changing stored manga data.
  parsed.searchParams.set('yomiri-cover', '2');
  return parsed.href;
}
